/* eslint-disable no-unused-vars */
import { css, StyleSheet } from 'aphrodite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import BackgroundImage from '../../assets/pro-background.jpg'
import tooltipWhite from '../../assets/tooltip-white.png'
import WidgetHomeHeader from '../../components/Widget/WidgetHomeHeader'
import INT from '../../config/index'
import { COLOR_BLACK } from '../../lib/colors'
import { leToBr } from '../../utils/Utils'
import { Inter } from '../../lib/fonts'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    minHeight: '596px',
    position: 'relative',
    '@media (max-width: 480px)': {
      height: 'auto',
    },
  },
  backgroundImage: {
    width: '100%',
    objectFit: 'cover',
    '@media (max-width: 480px)': {
      position: 'absolute',
      height: '100%',
      objectPosition: '70%',
    },
  },
  contentContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 2,
    display: 'flex',
    padding: '0px 10em',
    marginTop: '40px',
    gap: '5em',
    '@media (max-width: 480px)': {
      position: 'relative',
      top: '0px',
      left: '0px',
      padding: '0px',
      gap: '0px',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'flex-start',
    },
  },
  navbar: {
    position: 'absolute',
    zIndex: 10,
  },
  title: {
    position: 'absolute',
    width: '359px',
    height: '330px',
    left: '180px',
    top: '-110px',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 150,
    lineHeight: '120px',
    /* or 86% */
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '-0.03em',
    color: 'white',
    fontFamily: 'Helvetica Neue LT W05_75 Bd Ou',
    '@media (max-width: 480px)': {
      position: 'relative',
      fontWeight: '700',
      fontSize: 60,
      width: 'auto',
      lineHeight: '50px',
      padding: '0px',
      margin: '0px',
      top: '0px',
      left: '20px',
      height: '130px',
      marginTop: '115px',
    },
    '@media (max-width: 306px)': {
      position: 'absolute',
    },
  },
  proTitle: {
    position: 'absolute',
    width: '153px',
    height: '110px',
    left: '55px',
    top: '125px',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 110,
    letterSpacing: '-0.035em',
    lineHeight: '120px',
    /* identical to box height, or 115% */
    display: 'flex',
    alignitems: 'center',
    letterspacing: '-0.03em',
    color: '#88FF0F',
    '@media (max-width: 480px)': {
      position: 'relative',
      flexDirection: 'column-reverse',
      fontWeight: '700',
      fontSize: 40,
      width: '50vw',
      height: '130px',
      lineHeight: '50px',
      padding: '0px',
      margin: '0px',
      top: '0px',
      left: '-130px',
      marginTop: '152.5px',
    },
    '@media (max-width: 320px)': {
      left: '20px',
      marginTop: 0,
      height: 'auto',
    },
  },
  proDesc: {
    position: 'absolute',
    width: '800px',
    height: '30px',
    left: '30px',
    top: '360px',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '20px',
    /* or 114% */
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    display: 'flex',
    letterSpacing: '-0.03em',
    color: '#FFFFFF',
    '@media (max-width: 480px)': {
      position: 'relative',
      padding: '0px',
      margin: '0px',
      top: '0px',
      left: '20px',
      height: '160px',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '16px',
      marginTop: '40px',
      width: '80%',
    },
  },
  tooltipContainer: {
    position: 'absolute',
    left: '190px',
    top: '410px',
    margin: '80px 0px 30px 0px',
    '@media (max-width: 480px)': {
      position: 'relative',
      padding: '0px',
      margin: '0px',
      marginTop: '50px',
      marginBottom: '100px',
      top: '0px',
      width: '100%',
      left: '10%',
    },
    '@media (max-width: 306px)': {
      marginTop: '100px',
      marginBottom: '10px',
    },
  },
  tooltip: {
    display: 'flex',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
  },
  tooltipText: {
    margin: '0px',
    padding: '0px',
    position: 'absolute',
    color: COLOR_BLACK,
    fontWeight: 500,
    zIndex: 5,
    paddingLeft: '120px',
    alignSelf: 'center',
    '@media (max-width: 480px)': {
      fontSize: '12.5px',
      textAlign: 'center',
      padding: 0,
      width: '80%',
      fontWeight: 700,
    },
  },
  tooltipImg: {
    '@media (max-width: 480px)': {
      width: '80%',
    },
  },
  break: {
    flexBasis: '100%',
    height: '0',
  },
})
function ProMain() {
  const { t } = useTranslation('Pro')
  let navigate = useNavigate()

  return (
    <>
      <WidgetHomeHeader
        smallSize={window.innerWidth < 480 ? true : false}
        dynamicStyle={styles.navbar}
      />
      <div className={css(styles.container)}>
        <img
          src={BackgroundImage}
          className={css(styles.backgroundImage)}
          alt="background image women with laptop"
          width="100%"
          height="auto"
        />
        <div className={css(styles.contentContainer)}>
          <h1 className={css(styles.title)}>{leToBr(t('ourOffer'))}</h1>
          <p className={css(styles.proTitle)}>{t('pro')}</p>
          <div className={css(styles.break)}></div>
          <div className={css(styles.proDesc)}>
            <p style={{ margin: '0px 0 10px 0', fontSize: '1.2em' }}>
              {t('proDesc')}
            </p>
            <p style={{ margin: '0' }}>{t('AtPrice')}</p>
            <p style={{ margin: '0' }}>{t('hab')}</p>
            <p style={{ margin: '0' }}>{t('hab2')}</p>
            <p style={{ margin: '0', fontSize: '15px' }}>{t('Price')}</p>
          </div>
          <div className={css(styles.tooltipContainer)}>
            <span className="livepro">
              <button
                className={css(styles.tooltip)}
                type="button"
                onClick={() => {
                  if (INT.AUTH_PERM == true) {
                    navigate('../create-request')
                  }
                }}
              >
                <img
                  className={css(styles.tooltipImg)}
                  src={tooltipWhite}
                  alt="tooltip where do you want to go today ?"
                  width="auto"
                  height="auto"
                />
                <p className={css(styles.tooltipText)}>{t('launchLive')}</p>
              </button>
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProMain
